import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import 'firebase/auth';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  credential = {
    email: '',
    password: ''
  }

  constructor(private router: Router) {

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.router.navigate(['/home']);
      }
    });

  }

  ngOnInit() { }

  login() {
    if (this.credential.email.length < 6 || !this.credential.email.includes('@') || this.credential.password.length < 6) {
      alert('Preencha os campos corretamente');
      return;
    }
    firebase.auth().signInWithEmailAndPassword(this.credential.email, this.credential.password).then(r => {
      firebase.firestore().collection('store').doc(r.user.uid).get().then(store => {
        if (store.exists) {
          this.router.navigate(['/home']);
        } else {
          alert('Login direcionado para empresas');
          firebase.auth().signOut();
        }
      });
    }, e => {
      alert(e.message);
    });
  }

}
